import React from 'react';

import StepWithOptions from 'containers/Quiz/StepWithOptions';

import { LOVERS_TRACKING, QUIZ_ROUTE } from '..';

const CHOICES = [
  {
    id: 1,
    text: 'components.LoversQuiz.Steps.Sounds.choices.1',
    tracking: 'moans',
  },
  {
    id: 2,
    text: 'components.LoversQuiz.Steps.Sounds.choices.2',
    tracking: 'playful',
  },
  {
    id: 3,
    text: 'components.LoversQuiz.Steps.Sounds.choices.3',
    tracking: 'groans',
  },
];

const section = {
  sectionName: 'sounds',
  choices: CHOICES,
};

const Sounds = () => {
  return (
    <StepWithOptions
      section={section}
      question={{ id: 'components.LoversQuiz.Steps.Sounds.question' }}
      tracking={{ name: LOVERS_TRACKING, url: `${QUIZ_ROUTE}/sounds` }}
    />
  );
};

export default Sounds;
